<template>
  <div class="scroll-btn">
    <button class="scroll-btn__con" @click="scrollClick">
      SCROLL DOWN
    </button>
  </div>
</template>

<script>
  import routerControll from "../utils/routerControll";
  export default {
    methods:{
      scrollClick(){
        routerControll('next');

      },
    }
  }
</script>

<style lang="scss">
  .scroll-btn{
    @include position($position:absolute, $bottom:30px, $left:50%, $width:44px, $height:32px);
    z-index: 11;
    &:before{
      opacity: 0;
      @include position($position:absolute, $top:-34px, $left:-28px, $width:96px, $height:96px);
      @include bg($bg: '../assets/img/icon_ef.png', $cover:cover);
      content: '';
      pointer-events: none;
      transition: 0.3s;
    }
    &:hover{
      &:before{
        opacity: 1;
        transition: 0.3s;
      }
    }
    &__con{
      @include position($width:100%, $height:100%);
      @include bg($bg: '../assets/img/icon_down.png', $cover:cover);
      @include hide-text;

      &:after{
        @include position($position:absolute, $top:0px, $left:0px, $width:100%, $height:100%);
        @include bg($bg: '../assets/img/icon_down_ef.png', $cover:cover);
        content: '';
        animation: scroll-ani 1s alternate infinite;
      }
    }
    @include bp(tablet) {
      @include position($position:absolute, $bottom:25px, $left:50%, $width:44px*0.6, $height:32px*0.6);
      &:before{
        display: none;
      }
    }
  }
  @keyframes scroll-ani {
    0% {
      opacity:0;
    }
    100% {
      opacity:0.5;
    }
  }
</style>


